import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Option from './Option';
import Text from '../../../typography/Text';
import { useTheme } from '../../../../utils/styles';
const OptionsList = /*#__PURE__*/memo(_ref => {
  let {
    isLoading,
    options,
    isMulti,
    classes,
    override,
    onChange,
    mappedValue,
    checkboxColor,
    checkBoxIsMonotone,
    loadingMessage,
    noOptionsPlaceholder,
    truncateOptions
  } = _ref;
  const theme = useTheme();
  const renderOptions = useMemo(() => {
    if (!options || options.length === 0) {
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes.noOptions
      }, override.noOptions || {}), /*#__PURE__*/React.createElement(Text, {
        type: "body",
        color: theme.colors.utility.textSecondary
      }, noOptionsPlaceholder || 'No options'));
    }
    return options.map((current, index) => {
      if (current?.options?.length > 0) {
        return /*#__PURE__*/React.createElement("div", _extends({
          className: classes.optionListGroup
        }, override.optionListGroup || {}, {
          key: index
        }), current.label && /*#__PURE__*/React.createElement("div", _extends({
          className: classes.optionListGroupLabel
        }, override.optionListGroupLabel || {}), /*#__PURE__*/React.createElement(Text, {
          type: "subtitle",
          isTruncated: true
        }, current.label)), current.options.map((item, itemIndex) => {
          return /*#__PURE__*/React.createElement(Option, {
            key: itemIndex,
            option: item,
            isMulti: isMulti,
            classes: classes,
            override: override,
            isSelected: mappedValue[item.value],
            onChange: onChange,
            checkboxColor: checkboxColor,
            checkBoxIsMonotone: checkBoxIsMonotone,
            isTruncated: truncateOptions
          });
        }));
      } else {
        return /*#__PURE__*/React.createElement(Option, {
          key: index,
          option: current,
          isMulti: isMulti,
          classes: classes,
          override: override,
          isSelected: mappedValue[current.value],
          onChange: onChange,
          checkboxColor: checkboxColor,
          checkBoxIsMonotone: checkBoxIsMonotone,
          isTruncated: truncateOptions
        });
      }
    });
  }, [options, isMulti, classes, override, mappedValue, onChange, checkboxColor, checkBoxIsMonotone, noOptionsPlaceholder, truncateOptions, theme]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionList
  }, override.optionList || {}), isLoading && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.loaderContainer
  }, override.loaderContainer || {}), /*#__PURE__*/React.createElement(Text, {
    type: "body",
    color: theme.colors.utility.textSecondary
  }, loadingMessage || 'Loading...')), !isLoading && renderOptions);
});
process.env.NODE_ENV !== "production" ? OptionsList.propTypes = {
  isLoading: PropTypes.bool,
  options: PropTypes.array,
  isMulti: PropTypes.bool,
  classes: PropTypes.object,
  override: PropTypes.object,
  onChange: PropTypes.func,
  mappedValue: PropTypes.object,
  checkboxColor: PropTypes.string,
  checkBoxIsMonotone: PropTypes.bool,
  loadingMessage: PropTypes.string,
  noOptionsPlaceholder: PropTypes.string,
  truncateOptions: PropTypes.bool
} : void 0;
export default OptionsList;